// extracted by css-extract-rspack-plugin
export default {"heroImageContainer":"HeroImageHolder-module__heroImageContainer"};